<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <el-row>
            <el-col :span="4">
                <el-menu active-text-color="slategray" background-color="white" class="el-menu-vertical-demo"
                    default-active="2" text-color="slategray" @open="handleOpen" @close="handleClose">
                    <el-menu-item index="1">
                        <el-icon>
                            <document />
                        </el-icon>
                        <router-link to="/homepage/employee">员工管理</router-link>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <el-icon>
                            <setting />
                        </el-icon>
                        <router-link to="/homepage/charaManage">角色管理</router-link>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <el-icon>
                            <setting />
                        </el-icon>
                        <router-link to="/homepage/closetManage">服设管理</router-link>
                    </el-menu-item>
                    <el-menu-item index="4">
                        <el-icon>
                            <setting />
                        </el-icon>
                        <router-link to="/homepage/commissionManage">稿件管理</router-link>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="19">
                <router-view :employee="employeeList" :parentCurrentPage="parentCurrentPage"
                    :charaNameList="charaNameList" @refreshData="handleRefresh" />
            </el-col>
        </el-row>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onBeforeMount, onMounted, ref, unref, watch } from 'vue';
import service from '../utils/request'
import { useRoute } from 'vue-router'

const title = '主页'
const subtitle = '欢迎回来'
const route = useRoute()
const employeeList = ref({})
const charaNameList = ref()
const defaultPage = 1
const defaultPagesize = 10
const parentCurrentPage = ref(1)


const getEmployeeList = (currentPage, pagesize) => {
    const params = {
        page: currentPage,
        pageSize: pagesize,
        name: null
    };
    service.get("/admin/employee/page", { params })
        .then(res => {
            const total = res.data.total;
            const rst = res.data.records;
            if (rst.length != 0 && rst[0] != null) {
                let colName = Object.keys(rst[0]);
                const mapping = {
                    'name': '姓名',
                    'phone': '电话号码',
                    'sex': '性别',
                    'username': '用户名',
                    'idNumber': '身份证号',
                    'password': '密码',
                    'status': '状态',
                    'createTime': '创建时间',
                    'updateTime': '更新时间',
                    'createUser': '创建者',
                    'updateUser': '更新者'
                };

                // 使用map方法根据映射关系替换元素
                let colLabel = colName.map(item => mapping[item] || item);
                employeeList.value = { employeeInfo: rst, colName: colName, colLabel: colLabel, total: total };
            } else {
                console.error('返回员工信息为空', error);
            }

        }).catch(error => {
            console.error('获取员工信息失败', error);
        });
}



const getCharaNameList = () => {
    service.get("/admin/chara/listName")
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                charaNameList.value = rst.reduce((acc, item) => {
                    acc[item.id] = item.name; return acc;
                }, {})
            } else {
                console.error('返回角色信息为空', error);
            }
        }).catch(error => {
            console.error('获取角色信息失败', error);
        });
}



const handleRefresh = (currentPage, pagesize, id) => {
    if (route.path.includes('employee')) {
        getEmployeeList(currentPage, pagesize);
    }
};

onMounted(() => {
    getCharaNameList();
    getEmployeeList(defaultPage, defaultPagesize);
})


const handleOpen = () => {
    return
}

const handleClose = () => {
    return
}

</script>
<style scoped></style>
